import { createSelector } from '@reduxjs/toolkit';

import {
  selectCustomMonthlyPriceMethodChartDisplay,
  selectCustomMonthlyPriceMethodTableDisplay,
  selectCustomMonthlyRateMethodChartDisplay,
  selectCustomMonthlyRateMethodTableDisplay,
  selectZillowMethodChartDisplay,
  selectZillowMethodTableDisplay,
} from '../calculatedMarketAdjustmentSelectors/selectMarketAdjustmentsDisplay.ts';
import { selectMarketAdjustments } from '../orderSelectors.ts';
import { selectComparableSalesChartData } from '../selectComparableSalesChartData.ts';
import { selectMarketAdjustmentsCommentaryHelperText } from './selectMarketAdjustmentsCommentaryHelperText.ts';

const DEFAULT_ANALYSIS_PERIOD = 24;

const selectMarketAdjustmentsRenderData = createSelector(
  [selectMarketAdjustments],
  (marketAdjustments) => {
    const { dateOfSale, listToSale } = marketAdjustments.cachedForms;
    return {
      dateOfSale: dateOfSale.selectedMethod,
      listToSale,
    };
  },
);

export const selectMarketAdjustmentsCommentaryData = createSelector(
  [
    selectZillowMethodTableDisplay,
    selectCustomMonthlyRateMethodTableDisplay,
    selectCustomMonthlyPriceMethodTableDisplay,
    selectZillowMethodChartDisplay,
    selectCustomMonthlyRateMethodChartDisplay,
    selectCustomMonthlyPriceMethodChartDisplay,
    selectMarketAdjustmentsRenderData,
    selectMarketAdjustments,
    selectMarketAdjustmentsCommentaryHelperText,
    selectComparableSalesChartData,
  ],
  (
    zillowTable,
    customRateTable,
    customPriceTable,
    zillowChart,
    customRateChart,
    customPriceChart,
    { dateOfSale: method, listToSale },
    { commentary },
    helperText,
    comparableSalesDataTable,
  ) => {
    let chart = null;
    let table = null;

    switch (method) {
      case 'zillow':
        chart = zillowChart(DEFAULT_ANALYSIS_PERIOD);
        table = zillowTable(DEFAULT_ANALYSIS_PERIOD, 12);
        break;
      case 'customMonthlyRate':
        chart = customRateChart;
        table = customRateTable;
        break;
      case 'customMonthlyPrice':
        chart = customPriceChart;
        table = customPriceTable;
        break;
      default:
        break;
    }

    if (chart === null || table === null) return undefined;

    return {
      chart,
      table,
      method,
      commentary,
      helperText,
      listToSaleMethod: listToSale.selectedMethod,
      listToSaleRatio: listToSale.methodState.customRatio?.ratio,
      comparableSalesDataTable,
    };
  },
);
